import { MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_SHAPE_HEIGHT as SHAPE_HEIGHT } from 'yfilesExtensions/styles/modernized/consts';
import { MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_LABEL_WIDTH as LABEL_WIDTH } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import { MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT } from '@ardoq/graph-labeling';

export type RectLayout = {
  x: number;
  y: number;
  width: number;
  height: number;
};

/**
 * Calculates the export layout for the sub-shape (circle) of a collapsed component group.
 * Uses SHAPE_HEIGHT (50px) to match the visual circle size in the rendered diagram.
 */
export const calcCollapsedGroupSubShapeLayout = (
  nodeX: number,
  nodeY: number,
  nodeWidth: number,
  shapeY: number
): RectLayout => {
  const circleRadius = SHAPE_HEIGHT / 2;
  const cx = nodeX + nodeWidth / 2;
  const cy = nodeY + shapeY + circleRadius;

  return {
    x: cx - SHAPE_HEIGHT / 2,
    y: cy - SHAPE_HEIGHT / 2,
    width: SHAPE_HEIGHT,
    height: SHAPE_HEIGHT,
  };
};

/**
 * Calculates the export layout for the label of a collapsed component group.
 */
export const calcCollapsedGroupLabelLayout = (
  nodeCenterX: number,
  labelTop: number,
  lineCount: number
): RectLayout => ({
  x: nodeCenterX - LABEL_WIDTH / 2,
  y: labelTop,
  width: LABEL_WIDTH,
  height: lineCount * LINE_HEIGHT,
});
